import 'react';
import { jsx } from 'react/jsx-runtime';
function Logo() {
  return /*#__PURE__*/jsx("span", {
    className: "display-inline-block overflow-x-hidden",
    children: /*#__PURE__*/jsx("img", {
      height: "auto",
      width: "110px",
      src: "https://www.kbb.com/content/static/img/partner/kbb/KBB_Logo_Rev_White_RGB_Small.svg",
      alt: "Kelley Blue Book logo"
    })
  });
}
export { Logo as default };
